


















































import Vue from "vue";

export default Vue.extend({
  name: "yes-no-input",
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: false as boolean,
    };
  },
  created() {
    this.val = JSON.parse(JSON.stringify(this.value));
  },
  computed: {
    currentValue: {
      get(): boolean {
        return this.val;
      },
      set(value: boolean) {
        this.val = value;
      },
    },
  },
  methods: {
    updateValue(currentValue): void {
      let bln = JSON.parse(currentValue);
      this.$emit("input", bln);
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal;
    },
  },
});
